import api from "@/api/api";
import { iniciarRequisicao, logout } from "@/helpers";
import { STATUS_HTTP } from "@/api/statusHTTP";

export const atualizarEstoqueSeguranca = async (params) => {
  const url = '/compras/detalhes-produto/estoque-seguranca/editar';

  const { data, status } = await api.post(url, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return true;
}
